import { defineStore } from 'pinia'
import * as api from '@/api/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
  }),
  getters: {
    isAuthorized: (state) => !!state.token,
  },
  actions: {
    login(email: string, code: string) {
      return api
        .login({
          email,
          code,
        })
        .then(({ data }) => {
          this.token = data.token
          return data.token
        })
    },
    async logout() {
      await api.logout()
      this.token = ''
    },
  },
  persist: true,
})
